import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import DriverForm from './DriverForm';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { CustomButton } from '../../../../../../layout/styledcomponents/CustomButton';

const Drivers = () => {
    const { control } = useFormContext();

    const { fields, append, remove, replace, update } = useFieldArray({
        name: 'bookingInfo.drivers',
        control,
        shouldUnregister: false,
    });

    const handleAdd = () => {
        append({
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            licenceNo: '',
            licenceType: '',
        });
    };

    useEffect(() => {
        // initialise with a driver
        if (fields.length === 0) {
            replace({
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                licenceNo: '',
                licenceType: '',
            });
        }
    }, [fields]);

    return (
        <Grid
            sx={{
                width: '100%',
                display: 'flex',
                gap: '20px',
                flexDirection: 'column',
                paddingBottom: '30px',
            }}
        >
            <Grid
                sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
            >
                {' '}
                {fields?.map((driver: any, index: any) => (
                    <DriverForm
                        key={driver.id}
                        existingDriver={driver}
                        index={index}
                        update={update}
                        remove={remove}
                    />
                ))}
            </Grid>
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                <CustomButton
                    variant='contained'
                    color='primary'
                    startIcon={<AddCircleIcon />}
                    onClick={handleAdd}
                >
                    Additional Driver
                </CustomButton>
            </Grid>
        </Grid>
    );
};

export default Drivers;
